<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
export default {
  name: 'BranchDistrictGender',
  components: {
    MovieList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.$route.params.slug + '--movies/' },
      ]       
    }
  },
  data () {
    return {
      dorms: [],
      popupDorms: null,
      errors: [],
      gender: '',
      typeID: null,
      faculty: null
    }
  },
  methods: {
    checkGender () {
      if (this.$route.params.type === 'erkek') {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (this.$route.params.type === 'kiz') {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
  getDorms() {
    const id = window.localStorage.getItem('branchedDormId')
    const district = window.localStorage.getItem('district')
    const gender = window.localStorage.getItem('gender')
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
       const url = `/site/dorm/branches/${id}`
       axios.get(url)
         .then(response => {
           self.dorms = []
           if(response.data.branches) {
             window.localStorage.setItem('branchnumber', response.data.branches.length)
           if(gender === 'erkek') {
                response.data.branches.forEach(item => {
                    if(item.dorm_type_id === 1 && item.district.name === district) {
                self.dorms.push(item)
                    }
              })            
           } 
           else if(gender === 'kiz') {
                response.data.branches.forEach(item => {
                    if(item.dorm_type_id === 2 && item.district.name === district) {
                self.dorms.push(item)
                    }
              })            
           } 
           }        
    })
  }
  },
  computed: {
    pageTitle () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_title
        else if (this.typeID === 2) title = this.faculty.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_description
        else if (this.typeID === 2) title = this.faculty.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_keywords
        else if (this.typeID === 2) title = this.faculty.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
